import { DataBean } from "../../../DataBean";



export class MedicalDevice extends DataBean {


    public async getMedicalDeviceCatalog(type:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getMedicalDeviceCatalog_Number_String_Number_Number", [type,regexStr,page,recordsPerPage]);
    }


}